import React from 'react';
import { imageLinks } from 'assets/images';
import Svg from 'components/utils/Svg/Svg';
import ClosePrompt from 'components/utils/ClosePrompt/ClosePrompt';
import "./ChatWidgetHeader.scss";

interface ChatWidgetHeaderProps {
    closeWidget: () => void;
    handleBackAction: () => void;
}

const ChatWidgetHeader: React.FC<ChatWidgetHeaderProps> = ({ closeWidget, handleBackAction }) => {

    return (
        <div className='chat__header'>
            <div
                className='back__action d-inline-flex'
                onClick={handleBackAction}
                onKeyDown={e => {
                    if (e.key === 'Enter' || e.key === ' ') {
                        handleBackAction(); // Trigger the chat toggle on Enter or Space
                    }
                }}
                role='button'
                tabIndex={0} // Makes it focusable for keyboard navigation
                aria-label='Back to Chat '
            >
                <Svg src={imageLinks?.icon?.arrowLeft} title='back' />
            </div>
            <Svg src={imageLinks?.brandLogo} title='back' />
            <ClosePrompt closeWidget={closeWidget} />
        </div>
    );
};

export default ChatWidgetHeader;